{
  "nav": {
    "usuaris": "Usuarios",
    "rols": "Roles y permisos",
    "usuarisInformar": "Usuarios a informar",
    "arees": "Estructura",
    "documentacio": "Documentación",
    "circuits": "Circuitos de escalado",
    "canals": "Canales",
    "plantilles": "Plantillas",
    "zones": "Zonas",
    "integracions": "Integraciones",
    "versions": "Versiones de la app",
    "configuracio": "Configuración",
    "detallUsuari": "Detalle de usuario",
    "importacio": "Importación desde Excel",
    "politicaFitxers": "Política de ficheros",
    "detallDocument": "Detalle del documento"
  },
  "titols": {
    "usuaris": "Usuarios",
    "rols": "Roles y matriz de permisos",
    "usuarisInformar": "Usuarios a informar",
    "arees": "Estructura",
    "documentacio": "Biblioteca de documentación",
    "circuits": "Circuitos de escalado",
    "canals": "Canales y políticas de notificación",
    "plantilles": "Plantillas de mensaje",
    "zones": "Zonas y ubicaciones",
    "integracions": "Integraciones",
    "versions": "Versiones de la app y mensajes administrativos",
    "configuracio": "Configuración general y retención",
    "detallUsuari": "Detalle de usuario",
    "importacio": "Importación de usuarios a informar desde Excel",
    "politicaFitxers": "Política de ficheros",
    "detallDocument": "Detalle del documento"
  },
  "comu": {
    "carregant": "Cargando…",
    "desa": "Guardar",
    "desat": "Cambios guardados correctamente.",
    "cancella": "Cancelar",
    "edita": "Editar",
    "elimina": "Eliminar",
    "actiu": "Activo",
    "inactiu": "Inactivo",
    "tria": "Elige una opción",
    "torna": "Volver",
    "anterior": "Anterior",
    "seguent": "Siguiente",
    "enrere": "Atrás",
    "pagina": "Página {{actual}} de {{total}}",
    "recarrega": "Volver a cargar",
    "fa": {
      "ara": "ahora mismo",
      "min": "hace {{count}} min",
      "h": "hace {{count}} h",
      "dies": "hace {{count}} días"
    }
  },
  "altaPersona": {
    "boto": "Nueva persona",
    "titol": "Dar de alta a una persona",
    "etiqueta": "Personas",
    "ajuda": "Busca a la persona en el directorio corporativo (Entra ID) y elige qué rol tendrá y dónde.",
    "cerca": "Persona",
    "cercaPlaceholder": "Escribe nombre, apellidos o correo (mínimo 2 letras)",
    "cercant": "Buscando…",
    "senseResultats": "No se ha encontrado ninguna persona en el directorio.",
    "jaAlCai": "Ya está en el CAI",
    "canvia": "Cambiar",
    "rol": "Rol",
    "rolPlaceholder": "Elige un rol",
    "on": "Dónde se aplica",
    "global": "Toda la organización",
    "triaAmbit": "Busca departamento, área o servicio",
    "ambitTriat": "Ámbito",
    "crea": "Dar de alta",
    "cancella": "Cancelar"
  },
  "usuaris": {
    "sincronitza": "Sincronizar con Entra ID",
    "sincronitzant": "Sincronizando…",
    "resultatSync": "Sincronización completada: {{creats}} creados, {{actualitzats}} actualizados, {{desactivats}} desactivados.",
    "cerca": "Buscar por nombre, correo o UPN",
    "rol": "Rol",
    "totsRols": "Todos los roles",
    "departament": "Departamento",
    "totsDepartaments": "Todos los departamentos",
    "estat": "Estado",
    "totsEstats": "Todos los estados",
    "total": "{{count}} usuarios",
    "buit": "No hay usuarios que coincidan con los filtros.",
    "persona": "Persona",
    "carrec": "Cargo",
    "idioma": "Idioma",
    "ultimSync": "Última sincronización",
    "totsN": "Todos ({{count}})",
    "correu": "Correo corporativo",
    "sincronitzacio": "Sincronización",
    "sincronitzat": "Sincronizado",
    "pendent": "Pendiente"
  },
  "detallUsuari": {
    "titol": "Detalle de usuario",
    "afegeixRol": "Añadir rol",
    "rol": "Rol",
    "ambit": "Ámbito",
    "ambitId": "Elemento del ámbito",
    "treuRol": "Quitar el rol {{rol}}",
    "upn": "UPN",
    "email": "Correo electrónico",
    "telefon": "Teléfono",
    "idioma": "Idioma preferido",
    "ultimSync": "Última sincronización",
    "origenEntra": "Datos corporativos sincronizados desde Microsoft Entra ID",
    "canals": "Canales verificados",
    "senseCanals": "No tiene canales verificados.",
    "verificat": "Verificado",
    "noVerificat": "No verificado",
    "dispositius": "Dispositivos",
    "senseDispositius": "No tiene ningún dispositivo registrado.",
    "critiquesActives": "Alertas críticas activas",
    "critiquesInactives": "Alertas críticas desactivadas",
    "rolsGlobals": "Roles globales",
    "rolsAmbit": "Roles por área o servicio",
    "senseRols": "Sin roles asignados.",
    "activitat": "Actividad reciente",
    "abast": "Alcance",
    "areaServei": "Área / servicio",
    "assignat": "Asignado",
    "dadesEntra": "Datos corporativos (Entra ID)",
    "alDia": "Al día",
    "senseActivitat": "Sin actividad registrada",
    "resultatKo": "con error"
  },
  "rols": {
    "nou": "Nuevo rol",
    "codi": "Código",
    "nomCa": "Nombre (catalán)",
    "nomEs": "Nombre (castellano)",
    "descripcio": "Descripción",
    "sistema": "Rol del sistema",
    "cercaRecurs": "Filtrar recursos",
    "desaPermisos": "Guardar los permisos",
    "ajuda": "Los permisos son dinámicos: marca los accesos que tiene este rol sobre cada recurso. La asignación del rol a cada persona puede ser global o por área/servicio.",
    "desats": "Permisos del rol guardados.",
    "recurs": "Recurso",
    "acces": {
      "CONSULTAR": "Consultar",
      "ALTA": "Alta",
      "MODIFICAR": "Modificar",
      "ELIMINAR": "Eliminar"
    },
    "permisDe": "Permiso {{acces}} sobre {{recurs}}",
    "llista": "Roles",
    "permis": "Permiso",
    "abast": "Acceso",
    "actiu": "Activo",
    "actius": "{{count}} permisos activos",
    "senseResultats": "Ningún permiso coincide con la búsqueda",
    "grups": {
      "guardies": "Guardias",
      "activacions": "Activaciones",
      "organitzacio": "Áreas, servicios y documentación",
      "notificacions": "Notificaciones",
      "administracio": "Administración",
      "informes": "Informes y auditoría",
      "altres": "Otros"
    }
  },
  "informar": {
    "alta": "Añadir manualmente",
    "nom": "Nombre",
    "email": "Correo electrónico",
    "telefon": "Teléfono",
    "canals": "Canales",
    "importa": "Importar desde Excel",
    "servei": "Servicio",
    "cerca": "Buscar por nombre o correo",
    "resum": "{{total}} personas · {{manual}} manuales · {{entra}} de Entra ID · {{excel}} de Excel",
    "buit": "Este servicio no tiene usuarios a informar.",
    "origen": "Origen",
    "origens": {
      "MANUAL": "Manual",
      "ENTRA": "Entra ID",
      "EXCEL": "Importada de Excel"
    },
    "treu": "Quitar a {{nom}}",
    "totes": "Todas ({{count}})",
    "filtreOrigen": {
      "EXCEL": "Importadas de Excel ({{count}})",
      "ENTRA": "Entra ID ({{count}})",
      "MANUAL": "Manuales ({{count}})"
    },
    "nota": "Cada servicio (IT o de crisis) tiene su lista de usuarios a informar",
    "senseLlistes": "Ninguna lista coincide con los filtros",
    "persones": "Personas",
    "area": "Área",
    "senseCompte": "Sin cuenta corporativa",
    "reimporta": "Reimportar Excel",
    "exporta": "Exportar",
    "personesLlista": "Personas de la lista",
    "mostrant": "Mostrando {{count}} de {{total}}",
    "senseCompteBadge": "Sin cuenta corporativa"
  },
  "importacio": {
    "titol": "Importación de usuarios a informar",
    "fitxer": "Fichero Excel",
    "ajudaFitxer": "Fichero .xlsx o .xls · la primera fila debe contener las cabeceras.",
    "errorLectura": "No se ha podido leer el fichero. Comprueba que sea un Excel válido.",
    "llegides": "{{nom}}: {{files}} filas y {{columnes}} columnas",
    "noImportar": "No importar",
    "mapeigIncomplet": "Hay que asignar como mínimo las columnas de nombre y correo electrónico.",
    "filesLlegides": "{{count}} filas leídas",
    "valides": "Válidas",
    "duplicades": "Duplicadas",
    "errors": "Con errores",
    "validantServidor": "Validando en el servidor…",
    "servei": "Servicio de destino",
    "ajudaAssignacio": "Se asignarán {{count}} personas válidas al servicio seleccionado.",
    "resultat": "Importación completada: {{desats}} guardados de {{total}} ({{valids}} válidos, {{duplicats}} duplicados).",
    "importa": "Importar",
    "passos": {
      "fitxer": "{{n}}. Fichero",
      "mapeig": "{{n}}. Mapeo de columnas",
      "validacio": "{{n}}. Validación",
      "assignacio": "{{n}}. Asignación al servicio"
    },
    "camps": {
      "nom": "Nombre",
      "email": "Correo electrónico",
      "telefon": "Teléfono",
      "canals": "Canales"
    },
    "errorFila": {
      "obligatori": "Fila {{fila}}: el campo {{camp}} es obligatorio.",
      "email": "Fila {{fila}}: el {{camp}} no es válido.",
      "duplicat": "Fila {{fila}}: {{camp}} duplicado.",
      "telefon": "Fila {{fila}}: el {{camp}} no es válido."
    },
    "formatNoValid": "Solo se admiten ficheros de Excel (.xlsx o .xls).",
    "primerFitxer": "Elige primero un fichero Excel.",
    "campPlataforma": "Campo de la plataforma",
    "columnaExcel": "Columna del Excel",
    "exemple": "Ejemplo",
    "nValids": "{{count}} válidos",
    "ajudaValids": "Se pueden importar a la lista del servicio",
    "nDuplicats": "{{count}} duplicados",
    "ajudaDuplicats": "Se descartan las filas repetidas por el correo",
    "nErrors": "{{count}} con errores",
    "validaServidor": "Validar en el servidor",
    "validatServidor": "Validado en el servidor",
    "importaN": "Importar {{count}} personas"
  },
  "arees": {
    "novaArea": "Nueva área",
    "nouDepartament": "Nuevo departamento",
    "codi": "Código",
    "nom": "Nombre",
    "tipus": "Tipo",
    "nouServei": "Nuevo servicio",
    "descripcio": "Descripción",
    "tecnicGuardia": "Técnico de guardia",
    "tecnicGuardiaCrisi": "Opcional en áreas de crisis: se determina por el calendario del área.",
    "tecnicGuardiaIt": "Se determina por el calendario de guardia del área.",
    "expert": "Técnico experto",
    "senseExpert": "Sin técnico experto asignado.",
    "expertTipus": {
      "TITULAR": "Titular",
      "SUBSTITUT": "Sustituto"
    },
    "usuarisInformar": "Usuarios a informar",
    "resumInformar": "{{count}} personas ({{origen}})",
    "gestionaInformar": "Gestionar",
    "plantilla": "Plantilla de mensaje",
    "sensePlantilla": "Sin plantilla",
    "circuit": "Circuito de escalado",
    "circuitDefecte": "Circuito por defecto",
    "canalsDefecte": "Canales por defecto",
    "procediment": "Procedimiento alternativo",
    "documentacio": "Documentación",
    "totes": "Todas",
    "departaments": "Departamentos",
    "arees": "Áreas",
    "serveis": "Servicios",
    "senseArees": "Este departamento no tiene áreas.",
    "senseServeis": "Esta área no tiene servicios.",
    "ajudaCrisi": "El flujo de apertura es el mismo que para un servicio IT: Servicio, Tipo, Datos, Destinatarios y Revisión. Solo cambian los campos vacíos (técnico experto) y la plantilla, que añade zona, riesgo, peligros y medidas.",
    "area": "Área",
    "departament": "Departamento",
    "tipusArea": "Tipo de área",
    "circuitResum": "{{nom}} · {{count}} niveles",
    "tecnicGuardiaArea": "Técnico de guardia del área",
    "opcionalCrisi": "Opcional en áreas de crisis",
    "titularFins": "Titular · hasta {{data}}",
    "opcional": "Opcional",
    "mes": "+{{count}} más",
    "documentacioServei": "Documentación del servicio",
    "obreBiblioteca": "Abrir en la biblioteca",
    "senseDocuments": "Este servicio no tiene documentos",
    "configuracio": "Configuración del servicio",
    "tots": "Todos",
    "serveisDe": "Servicios de {{area}}",
    "triaServei": "Elige un servicio para ver su ficha"
  },
  "circuits": {
    "inici": "Activación",
    "fi": "Fin del escalado",
    "nivell": "Nivel {{n}}",
    "desti": {
      "TECNIC_GUARDIA_TITULAR": "Técnico de guardia titular",
      "TECNIC_GUARDIA_SUBSTITUT": "Técnico de guardia sustituto",
      "TECNIC_GUARDIA_DEPARTAMENT": "Técnico de guardia del departamento",
      "TECNIC_GUARDIA_ALTRES_AREES": "Técnicos de guardia de otras áreas",
      "EXPERT_TITULAR": "Técnico experto titular",
      "EXPERT_SUBSTITUT": "Técnico experto sustituto",
      "USUARI": "Persona concreta",
      "GRUP": "Grupo"
    },
    "immediat": "Inmediato",
    "espera": "Espera {{min}} min",
    "nou": "Nuevo circuito",
    "perDefecte": "Por defecto",
    "tempsTotal": "Tiempo total: {{min}} min",
    "diagrama": "Diagrama del circuito de escalado",
    "nom": "Nombre",
    "servei": "Servicio",
    "general": "General (todos los servicios)",
    "marcaDefecte": "Circuito por defecto",
    "nivells": "Niveles de escalado",
    "puja": "Subir el nivel {{n}}",
    "baixa": "Bajar el nivel {{n}}",
    "treu": "Quitar el nivel {{n}}",
    "amunt": "Arriba",
    "avall": "Abajo",
    "destinatari": "Destinatario",
    "destiNivell": "Destinatario del nivel {{n}}",
    "esperaMin": "Espera sin confirmación (min)",
    "esperaNivell": "Espera del nivel {{n}} en minutos",
    "afegeixNivell": "Añadir nivel",
    "senseCanals": "Cada nivel debe tener como mínimo un canal.",
    "llista": "Circuitos",
    "resum": "{{count}} niveles",
    "buit": "No hay circuitos configurados.",
    "persona": "Persona",
    "cercaPersona": "Buscar por nombre…",
    "personaNivell": "Persona del nivel {{n}}",
    "titolCircuit": "Circuito de escalado · {{nom}}",
    "esperaCurt": "Espera",
    "minuts": "{{n}} min",
    "senseUsuari": "Los niveles de tipo «Persona concreta» deben tener una persona asignada.",
    "descDesti": {
      "TECNIC_GUARDIA_TITULAR": "Titular del calendario de guardia del área",
      "TECNIC_GUARDIA_SUBSTITUT": "Sustituto según calendario",
      "TECNIC_GUARDIA_DEPARTAMENT": "Guardia del departamento · rotación",
      "TECNIC_GUARDIA_ALTRES_AREES": "Técnicos de guardia del resto de áreas del departamento",
      "EXPERT_TITULAR": "Técnico experto titular del servicio",
      "EXPERT_SUBSTITUT": "Técnico experto sustituto del servicio",
      "USUARI": "Persona sin asignar",
      "GRUP": "Grupo de destinatarios"
    },
    "editaNivell": "Editar el nivel {{n}}"
  },
  "canals": {
    "matriu": "Canales obligatorios por tipo de aviso",
    "ajuda": "Define para cada tipo de aviso los canales que se utilizan y el tiempo de confirmación antes de escalar.",
    "tipusAvis": "Tipo de aviso",
    "critica": "Puede ser crítica",
    "canalDe": "Canal {{canal}} para {{tipus}}",
    "tempsConfirmacio": "Tiempo de confirmación (min)",
    "tempsDe": "Tiempo de confirmación de {{tipus}} en minutos",
    "desaTipus": "Guardar {{tipus}}",
    "desaServei": "Guardar los canales de {{servei}}",
    "regles": "Reglas generales",
    "reintents": "Reintentos",
    "reintentsValor": "Hasta 3 reintentos por canal con espera exponencial.",
    "antiDuplicats": "Antiduplicados",
    "antiDuplicatsValor": "Clave de idempotencia por destinatario, canal y nivel (RF-058).",
    "idioma": "Idioma",
    "idiomaValor": "Cada destinatario recibe el mensaje en su idioma preferido (ca/es).",
    "excepcions": "Excepciones por servicio",
    "min": "min",
    "senseTipus": "No hay tipos de aviso configurados",
    "serveiArea": "Servicio · área",
    "canalsDefecte": "Canales por defecto"
  },
  "plantilles": {
    "nova": "Nueva plantilla",
    "idioma": "Idioma de la plantilla",
    "codi": "Código",
    "tipus": "Tipo",
    "titolMissatge": "Título",
    "cos": "Cuerpo del mensaje (correo)",
    "cosPush": "Texto de la notificación push",
    "cosVeu": "Locución de la llamada",
    "variables": "Variables disponibles",
    "previsualitzacio": "Previsualización por canal",
    "canal": "Canal de previsualización",
    "previaServidor": "Previsualizar en el servidor",
    "llista": "Plantillas",
    "buit": "No hay plantillas.",
    "insereix": "Inserta la variable en el texto"
  },
  "zones": {
    "nova": "Nueva zona",
    "edita": "Editar la zona",
    "editaZona": "Editar {{nom}}",
    "codi": "Código",
    "nom": "Nombre",
    "tipus": "Tipo",
    "adreca": "Dirección",
    "pare": "Zona superior",
    "sensePare": "Ninguna",
    "cerca": "Buscar zonas",
    "buit": "No hay zonas.",
    "tipusZona": {
      "CENTRE": "Centro",
      "PLANTA": "Planta",
      "BOTIGA": "Tienda",
      "OFICINA": "Oficina",
      "ALTRE": "Otro"
    },
    "zona": "Zona"
  },
  "integracions": {
    "prova": "Comprobar ahora",
    "provant": "Comprobando…",
    "cua": "Mensajes en cola",
    "latenciaP50": "Latencia p50",
    "latenciaP95": "Latencia p95",
    "ms": "{{n}} ms",
    "configuracio": "Configuración",
    "enviats": "Enviados",
    "fallits": "Fallidos",
    "ultimError": "Último error",
    "secrets": "Las credenciales se guardan en Azure Key Vault y nunca se muestran.",
    "actualitzat": "Estado actualizado: {{data}}",
    "estat": {
      "OK": "Operativa",
      "DEGRADAT": "Degradada",
      "KO": "Error",
      "DESCONEGUT": "Sin datos",
      "NO_CONFIGURAT": "No configurada"
    },
    "ENTRA": {
      "nom": "Microsoft Entra ID",
      "descripcio": "Inicio de sesión único y sincronización de usuarios, grupos y departamentos vía Microsoft Graph.",
      "config": "Permisos User.Read.All y Group.Read.All con consentimiento de administrador."
    },
    "ITCAU": {
      "nom": "ITCAU / HaloITSM",
      "descripcio": "Vínculo manual con la referencia de la incidencia ITCAU, sin sincronización de campos.",
      "config": "Referencia manual introducida en cada activación. Credenciales, si las hay, en Azure Key Vault."
    },
    "MAILJET": {
      "nom": "Mailjet (correo electrónico)",
      "descripcio": "Envío de correos y webhooks de entrega, apertura y rebote.",
      "config": "Remitente cai@cai.ba-tech.net con SPF y DKIM."
    },
    "TWILIO": {
      "nom": "Twilio (llamadas de voz)",
      "descripcio": "Llamadas automáticas con locución en catalán y castellano y confirmación con el teclado.",
      "config": "Webhooks protegidos con validación de X-Twilio-Signature."
    },
    "PUSH": {
      "nom": "Notificaciones push (APNs / FCM)",
      "descripcio": "Envío directo por FCM y APNs con alertas críticas de iOS y canal de alarma de Android.",
      "config": "Entitlement de alertas críticas y canal de alta importancia."
    },
    "darreraComprovacio": "Última comprobación"
  },
  "versions": {
    "nova": "Publicar versión",
    "publica": "Publicar",
    "plataforma": "Plataforma",
    "plataformes": {
      "IOS": "iOS",
      "ANDROID": "Android"
    },
    "versio": "Versión",
    "build": "Build",
    "notes": "Notas",
    "notesCa": "Notas (catalán)",
    "notesEs": "Notas (castellano)",
    "urlBotiga": "URL de la tienda",
    "minimaObligatoria": "Versión mínima obligatoria",
    "minimaDe": "Versión mínima {{plataforma}}",
    "cap": "Ninguna",
    "historial": "Historial de versiones",
    "publicada": "Publicada",
    "missatges": "Mensajes administrativos",
    "senseMissatges": "No hay mensajes administrativos.",
    "nouMissatge": "Nuevo mensaje",
    "editaMissatge": "Editar el mensaje",
    "tipus": "Tipo",
    "tipusMissatge": {
      "INFO": "Información",
      "ACTUALITZACIO": "Actualización disponible",
      "VERSIO_MINIMA": "Versión mínima",
      "MANTENIMENT": "Mantenimiento"
    },
    "titolCa": "Título (catalán)",
    "titolEs": "Título (castellano)",
    "cosCa": "Texto (catalán)",
    "cosEs": "Texto (castellano)",
    "versioMin": "Desde la versión",
    "versioMax": "Hasta la versión",
    "previa": "Previsualización en la app",
    "dacord": "De acuerdo",
    "minimes": "Versiones mínimas obligatorias",
    "darreraDe": "{{plataforma}} · última publicada",
    "missatge": "Mensaje",
    "vigencia": "Vigencia",
    "estat": "Estado",
    "indefinit": "Indefinido",
    "senseVersions": "Todavía no hay ninguna versión publicada.",
    "previsualitzacio": "Previsualización"
  },
  "configuracio": {
    "regional": "Idioma y huso horario",
    "idioma": "Idioma por defecto",
    "fus": "Huso horario",
    "escalatDefecte": "Tiempo de escalado por defecto (min)",
    "retencio": "Retención de datos",
    "anys": "Años de retención",
    "retencioMinima": "La retención mínima es de 3 años (RNF-009).",
    "ajudaRetencio": "Pasado este plazo, los registros, mensajes y evidencias se purgan o anonimizan automáticamente.",
    "procediment": "Procedimiento alternativo",
    "ajudaProcediment": "Se muestra en la app cuando la app o las notificaciones no funcionan.",
    "telefon": "Teléfono de emergencia",
    "procedimentCa": "Procedimiento (catalán)",
    "procedimentEs": "Procedimiento (castellano)",
    "auditoria": "Auditoría de cambios de configuración",
    "senseCanvis": "No hay cambios registrados.",
    "quan": "Fecha y hora",
    "qui": "Persona",
    "accio": "Acción",
    "clau": "Elemento",
    "previ": "Valor previo",
    "nou": "Valor nuevo",
    "resultat": "Resultado",
    "resultatOk": "Correcto",
    "resultatKo": "Error",
    "canvi": "Cambio"
  },
  "documents": {
    "puja": "Subir documento",
    "substitueix": "Nueva versión de {{titol}}",
    "tanca": "Cerrar",
    "pujant": "Subiendo…",
    "enviaAnalisi": "Subir y analizar",
    "ajudaAnalisi": "El fichero se analiza con antimalware antes de publicarse. Mientras dura el análisis el documento queda En análisis.",
    "fitxer": "Fichero",
    "politicaResum": "Formatos permitidos: {{formats}} · Tamaño máximo {{mida}} MB · Máximo {{max}} documentos por servicio",
    "formatInvalid": "El formato .{{ext}} no está permitido.",
    "massaGran": "El fichero supera el tamaño máximo de {{mida}} MB.",
    "servei": "Servicio",
    "titol": "Título",
    "categoria": "Categoría",
    "ambit": "Ámbito",
    "ambits": {
      "SERVEI": "Servicio",
      "AREA": "Área",
      "DEPARTAMENT": "Departamento"
    },
    "comentari": "Comentario de la versión",
    "politica": "Política de ficheros",
    "cerca": "Buscar documentos",
    "totsServeis": "Todos los servicios",
    "estat": "Estado",
    "totsEstats": "Todos los estados",
    "estats": {
      "PUBLICAT": "Vigente",
      "ESBORRANY": "En análisis",
      "BLOQUEJAT": "Bloqueado",
      "RETIRAT": "Retirado"
    },
    "escaneig": {
      "PENDENT": "En análisis",
      "NET": "Limpio",
      "INFECTAT": "Bloqueado por malware",
      "ERROR": "Error de análisis"
    },
    "buit": "No hay documentos.",
    "versio": "Versión",
    "vN": "v{{n}}",
    "actualitzat": "Última actualización",
    "responsable": "Responsable",
    "descarrega": "Descargar",
    "descarregaVersio": "Descargar la versión {{n}}",
    "novaVersio": "Sustituir (nueva versión)",
    "retira": "Retirar el documento",
    "confirmaRetirada": "Retirar",
    "motiu": "Motivo",
    "dades": "Datos del documento",
    "versioVigent": "Versión vigente",
    "senseVigent": "Sin versión vigente",
    "auditoria": "Auditoría",
    "senseAuditoria": "Sin registros de auditoría.",
    "versions": "Historial de versiones",
    "mida": "Tamaño",
    "pujatPer": "Subido por",
    "data": "Fecha",
    "analisi": "Análisis antimalware",
    "codi": "Código",
    "totsN": "Todos ({{count}})",
    "filtreEstat": {
      "PUBLICAT": "Vigentes ({{count}})",
      "ESBORRANY": "En análisis ({{count}})",
      "BLOQUEJAT": "Bloqueados ({{count}})",
      "RETIRAT": "Retirados ({{count}})"
    },
    "notaAmbits": "Solo se muestran los documentos de los ámbitos en los que tienes permiso de consulta o gestión",
    "serveiArea": "Servicio · área",
    "format": "Formato",
    "notaPeu": "Los documentos bloqueados, retirados o no válidos no se pueden abrir.",
    "metadades": "Metadatos",
    "conservacio": "Se conserva durante 3 años",
    "senseVersions": "Todavía no hay versiones",
    "notaCanvi": "Nota de cambio",
    "vigent": "Vigente",
    "substituida": "Sustituida",
    "ambitAcces": "Ámbito de acceso",
    "heretat": "Heredado del servicio",
    "descarregable": "Descarga permitida",
    "si": "Sí",
    "no": "No",
    "arrossega": "Arrastra el fichero aquí o selecciónalo",
    "analisiAbans": "Análisis de seguridad antes de publicar",
    "checkFormat": "Formato admitido",
    "checkMida": "Tamaño dentro del límite",
    "midaDe": "{{mida}} de {{max}} MB",
    "checkAntimalware": "Análisis antimalware",
    "checkAntimalwareText": "Se hace al subir el fichero, antes de publicarlo",
    "senseFitxer": "Todavía no has elegido ningún fichero"
  },
  "politica": {
    "titol": "Política de ficheros",
    "formats": "Formatos permitidos",
    "capFormat": "Hay que permitir como mínimo un formato.",
    "limits": "Límites",
    "midaMax": "Tamaño máximo por fichero (MB)",
    "maxDocuments": "Número máximo de documentos por servicio",
    "seguretat": "Seguridad",
    "antimalware": "Todos los ficheros se analizan con Microsoft Defender for Storage antes de publicarse.",
    "bloqueig": "Los ficheros infectados, retirados o no válidos quedan bloqueados y no se pueden descargar.",
    "historial": "Se conserva el historial de versiones y la auditoría de cada documento.",
    "formatsLimits": "Formatos y límites",
    "rebutjats": "Siempre rechazados",
    "darrerCanvi": "Último cambio: {{data}}",
    "sempreActiu": "Siempre activo",
    "noDisponibles": "Ficheros no disponibles",
    "consulta": "Consulta",
    "comportament": "Comportamiento",
    "impedida": "Impedida",
    "conservacio": "Conservación y auditoría",
    "controls": {
      "antimalware": {
        "titol": "Análisis antimalware obligatorio",
        "text": "Ningún documento se publica hasta superarlo"
      },
      "formatReal": {
        "titol": "Validación del formato real",
        "text": "Comprueba la firma, no solo la extensión"
      },
      "macros": {
        "titol": "Bloqueo de macros",
        "text": "Rechaza documentos con contenido activo"
      },
      "executables": {
        "titol": "Bloqueo de ejecutables y scripts",
        "text": "También dentro de ficheros comprimidos"
      },
      "marcaAigua": {
        "titol": "Marca de agua en la consulta",
        "text": "Nombre de la persona, fecha y hora"
      }
    },
    "estats": {
      "ESBORRANY": "En análisis",
      "BLOQUEJAT": "Bloqueado",
      "RETIRAT": "Retirado",
      "NO_VALID": "No válido"
    },
    "comportaments": {
      "ESBORRANY": "Se mantiene visible la versión vigente anterior",
      "BLOQUEJAT": "Fichero en cuarentena · aviso al responsable y al administrador",
      "RETIRAT": "Se muestra el documento que lo sustituye, si lo hay",
      "NO_VALID": "Fichero dañado o formato no admitido · hay que volver a subirlo"
    }
  },
  "auditoria": {
    "accions": {
      "CREAR": "Alta",
      "MODIFICAR": "Modificación",
      "ELIMINAR": "Baja",
      "CONSULTAR": "Consulta",
      "LOGIN": "Inicio de sesión",
      "LOGOUT": "Cierre de sesión",
      "ASSIGNAR_ROL": "Asignación de rol",
      "TREURE_ROL": "Retirada de rol",
      "SINCRONITZAR": "Sincronización",
      "CONFIRMAR": "Confirmación de recepción",
      "ACCEPTAR": "Aceptación",
      "DESCARREGAR": "Descarga",
      "PUJAR": "Subida",
      "RETIRAR": "Retirada",
      "PUBLICAR": "Publicación",
      "EXPORTAR": "Exportación",
      "PERMIS_DENEGAT": "Acceso denegado"
    },
    "entitats": {
      "usuari": "usuario",
      "rol": "rol",
      "activacio": "activación",
      "configuracio": "configuración",
      "document": "documento",
      "torn": "turno",
      "calendari": "calendario",
      "servei": "servicio",
      "area": "área",
      "plantilla": "plantilla",
      "circuit": "circuito de escalado",
      "sessio": "sesión",
      "dispositiu": "dispositivo",
      "appversio": "versión de la app",
      "informe_programat": "informe programado",
      "permis": "permiso",
      "zona": "zona",
      "tipusavis": "tipo de aviso",
      "sollicitud": "solicitud de cambio",
      "expert": "experto",
      "missatge": "mensaje",
      "departament": "departamento",
      "grup": "grupo",
      "circuit_escalat": "circuito de escalado",
      "app_versio": "versión de la app",
      "missatge_admin": "mensaje de administración",
      "tipus_avis": "tipo de aviso",
      "sollicitud_canvi_torn": "solicitud de cambio de turno",
      "document_versio": "versión de documento",
      "politica_fitxers": "política de ficheros",
      "rotacio": "rotación"
    },
    "accionsCompletes": {
      "usuari_edicio": "Modificación del perfil · usuario",
      "usuari_alta": "Alta de persona",
      "usuari_preferencies": "Cambio de preferencias",
      "usuari_telefon": "Cambio o confirmación del móvil",
      "usuari_rol_assignar": "Asignación de rol",
      "usuari_rol_revocar": "Retirada de rol",
      "usuari_sync_entra": "Sincronización con Entra ID",
      "usuari_sync_entra_individual": "Sincronización con Entra ID · usuario",
      "grup_membre_alta": "Alta de miembro · grupo",
      "grup_membre_baixa": "Baja de miembro · grupo",
      "servei_experts_desar": "Cambio de expertos · servicio",
      "servei_circuit_desar": "Cambio de circuito de escalado · servicio",
      "servei_usuari_informar_alta": "Alta de persona a informar · servicio",
      "servei_usuari_informar_edicio": "Modificación de persona a informar · servicio",
      "servei_usuari_informar_baixa": "Baja de persona a informar · servicio",
      "servei_usuaris_informar_import": "Importación de personas a informar · servicio",
      "rol_permisos_desar": "Cambio de permisos · rol",
      "document_politica_desar": "Cambio de política de ficheros",
      "document_politica_eliminar": "Eliminación de política de ficheros"
    },
    "canvis": {
      "senseCanvis": "Sin cambios de datos",
      "dades": "Datos registrados:",
      "eliminat": "Datos antes de la eliminación:",
      "mes_one": "… y {{count}} campo más",
      "mes_other": "… y {{count}} campos más",
      "si": "Sí",
      "no": "No",
      "per": "por {{qui}}"
    },
    "camps": {
      "nom": "Nombre",
      "cognoms": "Apellidos",
      "email": "Correo",
      "telefon": "Móvil",
      "telefonConfirmat": "Móvil confirmado",
      "departamentId": "Departamento",
      "areaId": "Área",
      "serveiId": "Servicio",
      "carrec": "Cargo",
      "idioma": "Idioma",
      "actiu": "Activo",
      "canalsPreferits": "Canales preferidos",
      "canalsDefecte": "Canales por defecto",
      "biometria": "Biometría",
      "campsLocals": "Campos bloqueados en la sincronización",
      "rols": "Roles",
      "codi": "Código",
      "descripcio": "Descripción",
      "tipus": "Tipo",
      "adreca": "Dirección",
      "pareId": "Zona padre",
      "plantillaId": "Plantilla",
      "circuitEscalatId": "Circuito de escalado",
      "procedimentAlternatiu": "Procedimiento alternativo",
      "entraGroupId": "Grupo de Entra ID",
      "entraOid": "Identificador de Entra ID",
      "upn": "Usuario (UPN)",
      "membres": "Miembros",
      "estat": "Estado",
      "titol": "Título",
      "versio": "Versión",
      "usuariId": "Persona",
      "calendariId": "Calendario",
      "inici": "Inicio",
      "fi": "Fin",
      "motiu": "Motivo",
      "comentari": "Comentario"
    },
    "verbs": {
      "alta": "Alta",
      "baixa": "Baja",
      "modificar": "Modificación",
      "eliminar": "Eliminación",
      "edicio": "Edición",
      "tancar": "Cierre",
      "escalar": "Escalado",
      "estat": "Cambio de estado",
      "expert": "Experto activado",
      "itcau": "Vinculación ITCAU",
      "destinataris": "Destinatarios",
      "retirar": "Retirada",
      "substituir": "Sustitución",
      "escaneig": "Análisis antimalware",
      "nova": "Nueva",
      "csv": "Exportación CSV",
      "consulta": "Consulta",
      "descarrega": "Descarga",
      "sincronitzar": "Sincronización",
      "confirmar": "Confirmación",
      "acceptar": "Aceptación"
    }
  },
  "ajustos": {
    "titol": "Configuración",
    "subtitol": "Todo lo que se configura una vez y se toca poco. Fuera del menú del día a día.",
    "cerca": "Busca un ajuste: «plantilla», «escalado», «importar»…",
    "cercaEtiqueta": "Buscar un ajuste",
    "senseResultats": "Ningún ajuste coincide con la búsqueda.",
    "grups": {
      "persones": "Personas",
      "organitzacio": "Organización",
      "comunicacio": "Comunicación",
      "documentacio": "Documentación",
      "sistema": "Sistema"
    },
    "items": {
      "usuaris": {
        "titol": "Usuarios",
        "text": "Altas, áreas y permisos de cada persona"
      },
      "rols": {
        "titol": "Roles",
        "text": "Qué puede hacer cada perfil"
      },
      "usuarisInformar": {
        "titol": "Usuarios a informar",
        "text": "Listas por servicio · importar desde Excel"
      },
      "arees": {
        "titol": "Estructura",
        "text": "Departamentos, áreas, servicios y guardias"
      },
      "zones": {
        "titol": "Zonas",
        "text": "Centros, plantas y ubicaciones"
      },
      "circuits": {
        "titol": "Circuitos de escalado",
        "text": "A quién se avisa y cuándo se escala"
      },
      "canals": {
        "titol": "Canales de aviso",
        "text": "App, SMS, correo y llamada; reintentos"
      },
      "plantilles": {
        "titol": "Plantillas de mensaje",
        "text": "Campos y textos por servicio"
      },
      "documentacio": {
        "titol": "Documentos de servicio",
        "text": "Procedimientos que se adjuntan a las activaciones"
      },
      "politicaFitxers": {
        "titol": "Política de ficheros",
        "text": "Tipos y tamaños permitidos"
      },
      "integracions": {
        "titol": "Integraciones",
        "text": "ITCAU, Entra ID, SMS"
      },
      "monitoratge": {
        "titol": "Monitorización",
        "text": "Estado de envíos y servicios"
      },
      "versions": {
        "titol": "Versiones de la app",
        "text": "Versión mínima y avisos de actualización"
      },
      "configuracio": {
        "titol": "Configuración general",
        "text": "Tiempos, idiomas y valores por defecto"
      }
    }
  }
}
